import { useState } from 'react';

import { _shortName } from './DealsPage.shared';
import styles from './DealsPage.module.css';

/** User-filter multi-select dropdown, extracted verbatim from DealsPage.tsx
 *  (D4 componentization, zero behavior change). */

interface UserFilterDropdownProps {
  selected: string[];
  options: string[];
  onChange: (next: string[]) => void;
}

export function UserFilterDropdown({ selected, options, onChange }: UserFilterDropdownProps) {
  const [open, setOpen] = useState(false);
  const label = selected.length === 0
    ? 'User filter'
    : `User filter (${selected.length})`;

  const toggle = (email: string) => {
    if (selected.includes(email)) onChange(selected.filter((e) => e !== email));
    else onChange([...selected, email]);
  };

  return (
    <div className={styles.userFilter}>
      <button
        type="button"
        className={styles.userFilterBtn}
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
      >
        {label} {open ? '▴' : '▾'}
      </button>
      {open && (
        <div className={styles.userFilterMenu}>
          {options.length === 0 && (
            <div className={styles.userFilterEmpty}>No users in current view</div>
          )}
          {options.map((email) => (
            <label key={email} className={styles.userFilterRow}>
              <input
                type="checkbox"
                checked={selected.includes(email)}
                onChange={() => toggle(email)}
              />
              <span>{_shortName(email)}</span>
            </label>
          ))}
          {selected.length > 0 && (
            <button
              type="button"
              className={styles.userFilterClear}
              onClick={() => onChange([])}
            >
              Clear
            </button>
          )}
        </div>
      )}
    </div>
  );
}
